import styled from 'styled-components';

export const CancelBreakUpMainWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l35} ${props.theme.spacing.large.l35};
    `
);

export const CancelBreakUpHeaderWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-bottom: ${props.theme.spacing.large.l15};
    `
);

export const BreakupHeaderMainText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const BreakupHeaderSubText = styled.p(
    props => `
        padding-top: ${props.theme.spacing.small.s8};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.green.base};
        font-weight: ${props.theme.font.fontWeight.bold};

        a{
            font-size: ${props.theme.font.base};
            color: ${props.theme.colors.blue.base};
            font-weight: ${props.theme.font.fontWeight.black};
            text-transform: uppercase;
            text-decoration: none;
            &:hover{
                color: ${props.theme.colors.blue.base};
            }
        }
    `
);

export const CancelBtnWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: ${props.theme.spacing.large.l20};
    `
);

export const BackOptionWrap = styled.div(
    props => `
        display: flex;
        align-items: center;
    `
);

export const BackOptionText = styled.a(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-decoration: none;
        cursor: pointer;
    `
);

export const CancelButtonWrap = styled.div(
    props => `
      display: flex;
      align-items: flex-end;
      flex-direction: column;
    `
);

export const CancelBtn = styled.button(
    props =>`
        outline: none;
        border: none;
        border-radius: 4rem;
        box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
        background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-transform: uppercase;
        cursor: pointer;
    `
);

export const CancelInfoText = styled.p(
    props => `
        padding-top: ${props.theme.spacing.base};
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.dark74};
    `
);